export const State3 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 6.55476V5.40945L9.61429 4.95132L9.29286 4.17108L9.92143 2.85397L9.11429 2.0451L7.82143 2.69649L7.04286 2.37437L6.55 1H5.40714L4.95714 2.38869L4.16429 2.71081L2.85 2.08089L2.04286 2.88976L2.69286 4.1854L2.37143 4.96564L1 5.4524V6.59055L2.38571 7.04868L2.70714 7.82892L2.07857 9.14603L2.88571 9.9549L4.17857 9.30351L4.95714 9.62563L5.45 11H6.58571L7.03571 9.61131L7.82857 9.28919L9.14286 9.91911L9.95 9.11024L9.29286 7.8146L9.62857 7.03436L11 6.54044V6.55476ZM6 8.15104C4.81429 8.15104 3.85714 7.19184 3.85714 6.00358C3.85714 4.81532 4.81429 3.85612 6 3.85612C7.18571 3.85612 8.14286 4.81532 8.14286 6.00358C8.14286 7.19184 7.18571 8.15104 6 8.15104Z"
      fill="#218358"
      stroke="#218358"
      strokeWidth="0.285714"
    />
  </svg>
);
